// extracted by mini-css-extract-plugin
export default {"noJobsMessage":"NoJobsMessage_noJobsMessage__tFSTt"};